import { useTranslation } from "react-i18next";
import SearchInput from "../search-input";
import { useThemesFilterStore } from "@/features/themes/stores";
import { Button } from "../ui/button";
import { PlusIcon } from "lucide-react";
import { ROUTES } from "@/constants/routes";
import { NavLink } from "react-router-dom";

const ThemesPageHeader = () => {
  const { searchValue, setSearchValue } = useThemesFilterStore();
  const { t } = useTranslation();
  return (
    <div className="flex-1 flex items-center justify-between w-full">
      <h1 className="lg:text-lg">{t("titles.dashboard.themes.list")}</h1>
      <div className="flex items-center gap-2 flex-1 justify-end">
        <SearchInput
          value={searchValue ?? ""}
          onChange={setSearchValue}
          className="max-w-72 hidden lg:flex"
        />
        <NavLink to={ROUTES.THEME_CREATE}>
          <Button>
            <PlusIcon />
            <span className="hidden sm:inline">
              {t("modules.themes.keys.add_theme")}
            </span>
          </Button>
        </NavLink>
      </div>
    </div>
  );
};

export default ThemesPageHeader;
